import 'zone.js/dist/zone-mix';
import 'reflect-metadata';
import '../polyfills';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

// Third-Party - NgBootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

// Third-Party - FontAwesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Third-Party - Others
import { SidebarModule } from 'ng-sidebar';
import { MomentModule } from 'ngx-moment';
import { ToastrModule } from 'ngx-toastr';
import { NgToggleModule } from '@nth-cloud/ng-toggle';
import { ClipboardModule } from 'ngx-clipboard';

// Routes
import { AppRoutingModule } from './app-routing.module';

// Providers
import { ApisService } from './services/apis.service';
import { HermesService } from './services/hermes.service';
import { ElectronService } from './services/electron.service';
import { NgbDateUKParserFormatter } from './services/ngb-date-uk-parser-formatter';

// Pipes
import { ToStonesPipe } from './pipes/to-stones.pipe';
import { ToLbsPipe } from './pipes/to-lbs.pipe';
import { OrdinalPipe } from './pipes/ordinal.pipe';
import { ObjPropertiesPipe } from './pipes/obj-properties.pipe';

// Components
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { JockeyWeightOutComponent } from './components/jockey-weight-out/jockey-weight-out.component';
import { JockeyWeightInComponent } from './components/jockey-weight-in/jockey-weight-in.component';
import { JockeyClaimComponent } from './components/jockey-claim/jockey-claim.component';
import { JockeyCommentsComponent } from './components/jockey-comments/jockey-comments.component';
import { RaceAuctionClaimComponent } from './components/race-auction-claim/race-auction-claim.component';
import { JockeyChangeComponent } from './components/jockey-change/jockey-change.component';
import { RaceCommentsComponent } from './components/race-comments/race-comments.component';
import { RaceWithdrawnComponent } from './components/race-withdrawn/race-withdrawn.component';
import { RaceConditionsComponent } from './components/race-conditions/race-conditions.component';
import { JockeyDisqualifyComponent } from './components/jockey-disqualify/jockey-disqualify.component';
import { JockeyWeightRuleBreachComponent } from './components/jockey-weight-rule-breach/jockey-weight-rule-breach.component';
import { AmendPositionComponent } from './components/amend-position/amend-position.component';
import { RaceConfirmWeighInComponent } from './components/race-confirm-weigh-in/race-confirm-weigh-in.component';
import { JockeyGearChecksComponent } from './components/jockey-gear-checks/jockey-gear-checks.component';
import { ScreenResolutionComponent } from './components/home/screen-resolution/screen-resolution.component';
import { JockeyWeightPenaltyComponent } from './components/jockey-weight-penalty/jockey-weight-penalty.component';
import { ConfirmActionComponent } from './components/confirm-action/confirm-action.component';
import { JockeyRoomLeaveComponent } from "./components/jockey-room-leave/jockey-room-leave.component";
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavbarComponent,
    JockeyWeightOutComponent,
    JockeyWeightInComponent,
    JockeyClaimComponent,
    JockeyCommentsComponent,
    RaceAuctionClaimComponent,
    JockeyChangeComponent,
    RaceCommentsComponent,
    RaceWithdrawnComponent,
    RaceConditionsComponent,
    ToStonesPipe,
    ToLbsPipe,
    LoginComponent,
    OrdinalPipe,
    ObjPropertiesPipe,
    JockeyDisqualifyComponent,
    JockeyWeightRuleBreachComponent,
    AmendPositionComponent,
    RaceConfirmWeighInComponent,
    JockeyGearChecksComponent,
    ScreenResolutionComponent,
    JockeyWeightPenaltyComponent,
    ConfirmActionComponent,
    JockeyRoomLeaveComponent,
    AuthCallbackComponent
  ],
  entryComponents: [
    JockeyWeightOutComponent,
    JockeyWeightInComponent,
    JockeyWeightRuleBreachComponent,
    JockeyClaimComponent,
    JockeyCommentsComponent,
    RaceAuctionClaimComponent,
    JockeyChangeComponent,
    JockeyDisqualifyComponent,
    RaceCommentsComponent,
    RaceWithdrawnComponent,
    RaceConditionsComponent,
    AmendPositionComponent,
    RaceConfirmWeighInComponent,
    JockeyGearChecksComponent,
    JockeyWeightPenaltyComponent,
    ConfirmActionComponent,
    JockeyRoomLeaveComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    SidebarModule.forRoot(),
    NgToggleModule,
    FontAwesomeModule,
    MomentModule,
    ClipboardModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    })
  ],
  providers: [
    ElectronService,
    HermesService,
    ApisService,
    ToStonesPipe,
    ToLbsPipe,
    { provide: NgbDateParserFormatter, useClass: NgbDateUKParserFormatter },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor() {
    // Add FontAwesome Icons
    library.add(fas);
  }

}
